import { render, staticRenderFns } from "./NewsCategoryListAddNew.vue?vue&type=template&id=71f14dcd&"
import script from "./NewsCategoryListAddNew.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports